import { useDispatch, useSelector } from "react-redux";
import "./MainMenu.css";
import {
    setSection,
    closePanels,
    openItem,
    hideSectionBanner,
    hideServiceList,
    hideTeamsMenu,
    showContentSection
} from "../features/serviceSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { toSlug } from "../utils/slug";
import { useEffect } from "react";


export default function MainMenu() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const segments = location.pathname.split("/").filter(Boolean);

    // Example:
    // /services/wardrobe-services/couture-hand-cleaning
    // ["services", "wardrobe-services", "couture-hand-cleaning"]

    const sectionSlug = segments[1];
    const itemSlug = segments[2];



    const {
        leftSection,
        activeSection,
        serviceData
    } = useSelector(state => state.service);

    useEffect(() => {
        if (!sectionSlug) {
            // dispatch(showHeroPanel());
            return;
        };

        const matchedSection = serviceData?.find(
            s => toSlug(s.title) === sectionSlug
        );

        if (!matchedSection) return;


        dispatch(setSection(matchedSection.title));

        if (itemSlug) {
            const matchedItem = matchedSection.items.find(
                i => toSlug(i.label) === itemSlug
            );
            if (matchedItem) dispatch(openItem(matchedItem));
        }
    }, [sectionSlug, itemSlug, dispatch, serviceData]);

    return (
        <div className={`services-menu right-content ${leftSection ? "" : "d-none"}`} style={{ display: "none" }}>
            <h3 className="menu-title"> Services</h3>

            <ul className="menu-list">
                {serviceData?.map((item, index) =>
                    item?.items?.map((p, i) =>
                        (i === 0 || i === 1) ? (
                            <li
                                key={`${index}-${i}`}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    dispatch(showContentSection());
                                    dispatch(openItem(p));
                                    navigate(
                                        `/services/${toSlug(item.title)}/${toSlug(p.label)}`
                                    );
                                }}
                            >
                                {p.label}
                            </li>
                        ) : null
                    )
                )}
            </ul>


            <ul className="menu-list separated">
                {serviceData?.map((item, index) => (
                    <li onClick={(e) => {
                        e.stopPropagation();
                        dispatch(showContentSection());
                        dispatch(setSection(item.title));
                        dispatch(hideTeamsMenu());
                        dispatch(closePanels());
                        setTimeout(() => {
                            if (activeSection !== item.title) {
                                dispatch(hideSectionBanner());
                                dispatch(hideServiceList());
                                setTimeout(() => {
                                    navigate(`/services/${toSlug(item.title)}`);
                                }, 900)
                            } else {
                                navigate(`/services/${toSlug(item.title)}`);
                            }
                        }, 0)

                    }} key={index}>{item.button_text}</li>
                ))}
            </ul>

            <ul className="menu-list info">
                <li onClick={(e) => {
                    e.stopPropagation();
                    navigate(`/philosophy`);
                }}>SERVICE PHILOSOPHY</li>
                <li onClick={(e) => {
                    e.stopPropagation();
                    navigate(`/team`);
                }}>PEOPLE</li>
            </ul>


            <div onClick={(e) => {
                e.stopPropagation();
                // dispatch(showContentSection());
                // dispatch(hideTeamsMenu());
                // dispatch(hideServiceList());
                // dispatch(hideServicePhilosophy());
                // dispatch(hideFaq());
                // dispatch(showContact());
                navigate(`/contact`);
            }} className="contact">CONTACT</div>
        </div>
    );
}
